import TemplateView from '../../../../TemplateView'
import CounterWithProgressBar from "../../../../components/counterCPT/CounterWithProgressBar";
import {HierarchyLevels} from "constants";

export default class WorkAssignmentsCellContent extends TemplateView {
    constructor({
        onCustomersClick = (e) => {},
        onProjectsClick = (e) => {},
        onTasksClick = (e) => {},
        onMouseIn = (e) => {},
        onMouseOut = (e) => {},
        onMouseMove = (e) => {},
    }) {
        super(null)

        this.params = {
            onCustomersClick,
            onProjectsClick,
            onTasksClick,
            onMouseIn,
            onMouseOut,
            onMouseMove,
        }

        this.state = {
            viewerManagementCounters: {
                customers: 0,
                projects: 0,
                tasks: 0,
            },
            customers: 0,
            projects: 0,
            tasks: 0,
            allScope: false,
            noEnterTTPermission: false,
        }

        this.onStateDeeplyChanged(() => {
            this.$el.toggleClass('noEnterTTPermission', this.state.noEnterTTPermission)
            this.$el.toggleClass('allScope', this.state.allScope && !this.state.noEnterTTPermission)

            if (!this.state.allScope && !this.state.noEnterTTPermission) {
                const viewerManagementCustomers = this.state.viewerManagementCounters.customers
                this.customersCounter.setState({
                    curValue: this.state.customers,
                    maxValue: viewerManagementCustomers,
                    all: viewerManagementCustomers > 0 && this.state.customers >= viewerManagementCustomers,
                    pale: true,
                    active: viewerManagementCustomers > 0,
                })
                this.$c.toggleClass('inactive', viewerManagementCustomers === 0)
                this.$c.toggleClass('active', viewerManagementCustomers > 0)

                const viewerManagementProjects = this.state.viewerManagementCounters.projects
                this.projectsCounter.setState({
                    curValue: this.state.projects,
                    maxValue: viewerManagementProjects,
                    all: viewerManagementProjects > 0 && this.state.projects >= viewerManagementProjects,
                    pale: true,
                    active: viewerManagementProjects > 0,
                })
                this.$p.toggleClass('inactive', viewerManagementProjects === 0)
                this.$p.toggleClass('active', viewerManagementProjects > 0)

                const viewerManagementTasks = this.state.viewerManagementCounters.tasks
                this.tasksCounter.setState({
                    curValue: this.state.tasks,
                    maxValue: viewerManagementTasks,
                    all: viewerManagementTasks > 0 && this.state.tasks >= viewerManagementTasks,
                    pale: true,
                    active: viewerManagementTasks > 0,
                })
                this.$t.toggleClass('inactive', viewerManagementTasks === 0)
                this.$t.toggleClass('active', viewerManagementTasks > 0)
            }
        })
    }

    messageKeys() {
        return {
            allScopeLabel: 'userlist.work_assignments.table.cell.all_scope',
            noEnterTTPermissionLabel: 'userlist.work_assignments.table.cell.no_enter_tt_permission'
        }
    }

    templateHtml() {
        return '<div class="workAssignmentsTab_workAssignmentsCell">' +
               '   <div class="customers"></div>' +
               '   <div class="projects"></div>' +
               '   <div class="tasks"></div>' +
               '   <div class="allScopeLabel"><%-allScopeLabel%></div>' +
               '   <div class="noEnterTTPermissionLabel"><%-noEnterTTPermissionLabel%></div>' +
               '</div>'
    }

    afterRender() {
        this.$el
            .mousemove(this.params.onMouseMove)
            .hover(this.params.onMouseIn, this.params.onMouseOut)

        this.$c = this.find('.customers').click((e) => {
            if (this.state.viewerManagementCounters.customers > 0)
                this.params.onCustomersClick(e)
        })
        this.customersCounter = new CounterWithProgressBar({
            hierarchyLevel: HierarchyLevels.CUSTOMER,
            hasProgressBar: true,
        }).init(this.$c)
        this.customersCounter.setState({pale: true})

        this.$p = this.find('.projects').click((e) => {
            if (this.state.viewerManagementCounters.projects > 0)
                this.params.onProjectsClick(e)
        })
        this.projectsCounter = new CounterWithProgressBar({
            hierarchyLevel: HierarchyLevels.PROJECT,
            hasProgressBar: true,
        }).init(this.$p)
        this.projectsCounter.setState({pale: true})

        this.$t = this.find('.tasks').click((e) => {
            if (this.state.viewerManagementCounters.tasks > 0)
                this.params.onTasksClick(e)
        })
        this.tasksCounter = new CounterWithProgressBar({
            hierarchyLevel: HierarchyLevels.TASK,
            hasProgressBar: true,
        }).init(this.$t)
        this.tasksCounter.setState({pale: true})
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/workAssignmentsTab/components/WorkAssignmentsCellContent.js